<p-dialog [(visible)]="displayDialog" [modal]="true" [draggable]="false" (onHide)="closeDialog()">
    <ng-template pTemplate="header">
        <h4><i class="pi pi-lock"></i> Cambio de número de teléfono</h4>
    </ng-template>
    <ng-template pTemplate="content">
        <p-messages key="user" [closable]="false" class="mb-5"></p-messages>
        <form [formGroup]="usernameForm" (ngSubmit)="changeUsername()" class="m-2">
            <div class="field my-5">
                <span class="p-input-icon-right p-float-label w-full">
                    <i *ngIf="this.usernameForm.status ==='PENDING'" class="pi pi-spin pi-spinner"></i>
                    <input type="text" id="username" pInputText class="p-inputtext-lg w-full" formControlName="username"
                        maxlength="10" minlength="10" autofocus="true"
                        [class.ng-invalid]="this.usernameForm.get('username')?.invalid && this.usernameForm.get('username')?.touched" />
                    <label htmlFor="username">Nuevo número de celular</label>
                </span>
            </div>
        </form>
    </ng-template>
    <ng-template pTemplate="footer">
        <p-button label="Cancelar" icon="pi pi-times" class="grey" (onClick)="closeDialog()" ariaLabel="Cancelar"></p-button>
        <p-button label="Aceptar" icon="pi pi-check" (onClick)="changeUsername()" [disabled]="this.usernameForm.invalid" ariaLabel="Aceptar"></p-button>
    </ng-template>
</p-dialog>